'use client';

import { alpha, Box, Skeleton } from '@mui/material';

export const TraderProfileCardSkeleton = () => {
  return (
    <Box
      sx={{
        height: '100%',
        p: 1.5,
        overflow: 'hidden',
      }}
    >
      {/* Header Section Skeleton */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 1.5 }}>
        <Skeleton
          variant="circular"
          width={48}
          height={48}
          sx={{ bgcolor: (theme) => alpha(theme.palette.text.primary, 0.1), flexShrink: 0 }}
        />
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Skeleton
            variant="text"
            width="60%"
            height={32}
            sx={{ bgcolor: (theme) => alpha(theme.palette.text.primary, 0.1) }}
          />
          <Skeleton
            variant="text"
            width="40%"
            height={20}
            sx={{ bgcolor: (theme) => alpha(theme.palette.text.primary, 0.1) }}
          />
        </Box>
      </Box>

      {/* Stats Section Skeleton — value (large) above label (small), per StatItem */}
      <Box sx={{ display: 'flex', flexWrap: 'wrap', mt: 2 }}>
        {[1, 2, 3].map((i) => (
          <Box key={i} sx={{ display: 'flex', alignItems: 'center' }}>
            <Box>
              <Skeleton
                variant="text"
                width={90}
                height={28}
                sx={{ bgcolor: (theme) => alpha(theme.palette.text.primary, 0.1), mb: 0.3 }}
              />
              <Skeleton
                variant="text"
                width={70}
                height={18}
                sx={{ bgcolor: (theme) => alpha(theme.palette.text.primary, 0.1) }}
              />
            </Box>
            {i < 3 && (
              <Box
                sx={{
                  width: '1px',
                  height: 32,
                  bgcolor: (theme) => alpha(theme.palette.divider, 0.6),
                  mx: { xs: 2, sm: 3 },
                }}
              />
            )}
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default TraderProfileCardSkeleton;
